/**
 * Copy for the B2B netting disclosure.
 * The consumer funnel's equivalents (field names as mapped in `libs/cms-sanity-schema`, where
 * some carry a group prefix such as `electricityCostDetails_`):
 * - `summary`       → `electricityCostDetails.redeliveryLabel` (already present on the SME renderings too)
 * - `periodHeading` → `electricityCostDetails.redeliveryLabel` + year
 * - `refund`        → `electricityCostDetails.redeliveryTariffLabel` + year (already present on the SME renderings)
 * - `popover`       → `electricityCostDetails.redeliveryTariffPopoverDescription`
 * - `offerCardNote` → `tariffSplitExplanationText` (consumer offer card, `productDetails.tariffSplitExplanation`)
 * - `netted`        → no consumer equivalent yet; needs a new field
 * Once the Sanity fields exist, build a `NettingDisclosureCopy` from `textualData` and pass it to the builder.
 */
export interface NettingDisclosureCopy {
  summary: string;
  popover: (nettingEndDate: string) => string;
  periodHeading: (year: number) => string;
  netted: (year: number) => string;
  refund: (year: number) => string;
  calculation: (rate: string, volume: string) => string;
  offerCardNote: (nettingEndDate: string) => string;
}

export const nettingDisclosureCopy: NettingDisclosureCopy = {
  summary: 'Teruglevering',
  popover: nettingEndDate =>
    `Tot ${nettingEndDate} wordt de stroom die je teruglevert eerst verrekend met de stroom die je verbruikt (salderen). Over wat daarna overblijft ontvang je een terugleververgoeding. Vanaf ${nettingEndDate} stopt salderen en ontvang je voor alle stroom die je teruglevert een terugleververgoeding.`,
  periodHeading: year => `Teruglevering ${year}`,
  netted: year => `Gesaldeerd met je verbruik ${year}`,
  refund: year => `Terugleververgoeding ${year}`,
  calculation: (rate, volume) => `${rate} × ${volume} =`,
  offerCardNote: nettingEndDate =>
    `Vanaf ${nettingEndDate} stopt de salderingsregeling. In je aanbod houden we alvast rekening met twee tariefperiodes: tot en na ${nettingEndDate}.`,
};
